import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = getFeaturedComics();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">热门推荐</h2>
            <p className="text-sm text-foreground-500">编辑精选 · 不可错过的韩漫佳作</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫在线免费阅读`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-accent-500 text-background-50 dark:text-foreground-950'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <div className="flex items-center gap-1 text-background-50/80 text-xs">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    <span>{comic.rating}</span>
                    <span className="mx-1">·</span>
                    <span>{comic.chapters}话</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">{comic.author}</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}